import { render, staticRenderFns } from "./ReportStaleBanner.vue?vue&type=template&id=629b9684&scoped=true"
import script from "./ReportStaleBanner.vue?vue&type=script&lang=js"
export * from "./ReportStaleBanner.vue?vue&type=script&lang=js"
import style0 from "./ReportStaleBanner.vue?vue&type=style&index=0&id=629b9684&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629b9684",
  null
  
)

export default component.exports